/* ADD GROUPS */
export const EDIT_ANSWER = "EDIT_ANSWER"
export const EDIT_ANSWER_SUCCESS = "EDIT_ANSWER_SUCCESS"
export const EDIT_ANSWER_CLEAN = "EDIT_ANSWER_CLEAN"
export const EDIT_ANSWER_ERROR = "EDIT_ANSWER_ERROR"
